import { router } from "@inertiajs/react"
import { Archive, CheckCheck, RotateCcw, Trophy } from "lucide-react"
import { Button } from "@/components/ui/button"

type BulkActionBarProps = {
  readonly selectedIds: readonly number[]
  readonly onClear: () => void
}

export function BulkActionBar({ selectedIds, onClear }: BulkActionBarProps) {
  if (selectedIds.length === 0) return null

  const submit = (action: "archive" | "unarchive" | "mark_read" | "won") => {
    router.post(
      "/replies/bulk",
      { bulk_action: action, ids: selectedIds.join(",") },
      {
        preserveScroll: true,
        onSuccess: onClear,
      },
    )
  }

  return (
    <div className="flex flex-wrap items-center gap-2 rounded-lg border border-hairline bg-page p-3">
      <span className="mr-auto text-sm text-ink-muted">{selectedIds.length} selected</span>
      <Button type="button" variant="secondary" size="sm" onClick={() => submit("archive")}>
        <Archive className="h-4 w-4" />
        Archive
      </Button>
      <Button type="button" variant="secondary" size="sm" onClick={() => submit("unarchive")}>
        <RotateCcw className="h-4 w-4" />
        Unarchive
      </Button>
      <Button type="button" variant="secondary" size="sm" onClick={() => submit("mark_read")}>
        <CheckCheck className="h-4 w-4" />
        Mark read
      </Button>
      <Button type="button" variant="secondary" size="sm" onClick={() => submit("won")}>
        <Trophy className="h-4 w-4" />
        Won
      </Button>
      <Button type="button" variant="ghost" size="sm" onClick={onClear}>
        Clear
      </Button>
    </div>
  )
}
